import { isVideoMedia, pickPreferredImageMedia } from "@wags/catalog/pure.ts";
import {
    SHARE_PREVIEW_HEIGHT,
    SHARE_PREVIEW_WIDTH,
    type SharePreviewMedia,
} from "@wags/catalog/share-preview/share-preview.contract.ts";

type ShareMedia = {
    id?: string | null;
    url?: string | null;
    mimeType?: string | null;
};

export function dogListingOgImageUrl(media: ShareMedia[]) {
    return (
        pickPreferredImageMedia(
            media.filter((item) => item.url),
            null,
        )?.url ?? undefined
    );
}

export function sharePreviewSeoMedia(preview: SharePreviewMedia) {
    return {
        url: preview.imageUrl,
        mimeType: "image/jpeg",
        video: {
            url: preview.videoUrl,
            width: SHARE_PREVIEW_WIDTH,
            height: SHARE_PREVIEW_HEIGHT,
        },
    };
}

export function dogListingShareMedia(
    detail:
        | {
              media: ShareMedia[];
              ogImageUrl?: string | null;
              sharePreview?: SharePreviewMedia | null;
          }
        | null
        | undefined,
) {
    if (detail?.sharePreview) return sharePreviewSeoMedia(detail.sharePreview);
    const generated = detail?.ogImageUrl ?? null;
    return {
        url: generated ?? dogListingOgImageUrl(detail?.media ?? []),
        mimeType: generated ? "image/png" : undefined,
        video: undefined,
    };
}

export function dogListingJsonLdImages(media: ShareMedia[]) {
    return media.flatMap((item) => {
        if (!item.url || isVideoMedia(item)) {
            return [];
        }
        return [item.url];
    });
}
